import { TFormFieldsAndRules_New } from '@verifime/components';
import { TIdentityDocumentType } from '@verifime/utils';
import { TOcrData } from '../types';

export const documentLabelMapping: { [documentType in TIdentityDocumentType]: string } = {
  DriverLicence: "driver's licence",
  MedicareCard: 'medicare card',
  Passport: 'passport',
  // UNAPPROVED DRAFT (verifime-adr#816): to be approved with the stakeholder in the running build
  ImmiCard: 'ImmiCard',
  OtherIdentityDocument: 'other identity document',
  // UNAPPROVED DRAFT (verifime-adr#816): to be approved with the stakeholder in the running build
  PhotoCard: 'photo card',
};

export function checkIsEmptyForm(formData: Record<string, any>) {
  const copyiedFormData = { ...formData };
  delete copyiedFormData.type;
  const isEmptyForm = Object.values(copyiedFormData).every(
    (value) => !value || Object.keys(value || {}).length < 1,
  );
  return isEmptyForm;
}

// Explicit mapping from TIdentityDocumentType to TOcrData keys
export const ocrTypeToDataKey: Record<TIdentityDocumentType, keyof TOcrData> = {
  Passport: 'passport',
  ImmiCard: 'immiCard',
  DriverLicence: 'driverLicence',
  MedicareCard: 'medicareCard',
  OtherIdentityDocument: 'otherIdentityDocument',
  PhotoCard: 'photoCard',
};

export function filterDocumentData(
  initialData: TOcrData,
  documentType: TIdentityDocumentType,
  formFieldsAndRules: TFormFieldsAndRules_New,
) {
  const dataKey = ocrTypeToDataKey[documentType];
  const rawData = (initialData?.[dataKey] as Record<string, unknown>) || {};
  return Object.values(formFieldsAndRules).reduce<Record<string, unknown>>((filtered, fields) => {
    fields.forEach((field) => {
      if (field.fieldName in rawData) {
        filtered[field.fieldName] = rawData[field.fieldName];
      }
    });
    return filtered;
  }, {});
}
